<template>
  <section class="flex level-1">

    <!-- //TITLE MOBILE -->
      <div class="mobile"  :class="{isMobile:isMobile}">
        <div class="link">
          <button class="bt btn-back" @click="goBack()">
            <font-awesome-icon :icon="['far', 'angle-left']"/>
          </button>
          <h2>Jeu concours</h2>
        </div>
        <div class="sep"></div>
      </div>
    <!-- //TITLE MOBILE -->


    <!-- TABS -->
    <div class="block__challengesMobile">
      <Stack height="4.25rem"></Stack>
        <b-tabs class="challenges-mobile" v-model="tabIndex" >
          <b-tab data-name="accueil" title="Accueil"><ChallengesAccueil :mobile="false"></ChallengesAccueil></b-tab>
          <b-tab data-name="classement" title="Classement" ><ChallengesClassement  :mobile="false"></ChallengesClassement></b-tab>
          <b-tab data-name="Excursions" title="Excursions"><ChallengesExcursions  :mobile="false"></ChallengesExcursions></b-tab>
          <b-tab data-name="Destinations" title="Destinations"><ChallengesDestinations  :mobile="false"></ChallengesDestinations></b-tab>
          <b-tab data-name="Actualites" title="Actualités"><ChallengesNews :mobile="false"></ChallengesNews></b-tab>
          <b-tab data-name="Reglement" title="Règlement" :lazy="true"><ChallengesLawMobile  :mobile="false" v-on:parentactive="activeTheTab"></ChallengesLawMobile></b-tab>
        </b-tabs>
    </div>
    <!-- TABS -->

    <!-- ROUTER -->
    <transition name="modal">
      <keep-alive>
        <router-view name="addContact" class="myModal"></router-view>
      </keep-alive>
    </transition>
    <!-- ROUTER -->

  </section>
</template>


<script>
// import ParentMixin from '../../ParentMixin'
import { mapGetters } from 'vuex'
import ChallengesAccueil from '../challenges/ChallengesAccueil'
import ChallengesClassement from '../challenges/ChallengesClassement'
import ChallengesExcursions from '../challenges/ChallengesExcursions'
import ChallengesDestinations from '../challenges/ChallengesDestinations'
import ChallengesNews from '../challenges/ChallengesNews'
import ChallengesLawMobile from '../challenges/ChallengesLawMobile'
import Stack from '../../../module/stack/Stack'

export default {
  name:"challengesMobile",
    components:{
      ChallengesAccueil,
      ChallengesClassement,
      ChallengesExcursions,
      ChallengesDestinations,
      ChallengesNews,
      ChallengesLawMobile,
      Stack
    },
    mixins: [
      // ParentMixin
    ],
    computed: {
      ...mapGetters([
          'getIsMobile'
      ])
    },
    data () {
      return {
        content:"",
        isMobile:false,
        tabIndex:0,
      }
    },
    mounted(){

    },
    created (){
      this.isMobile = this.getIsMobile;
      this.activeTab();
      this.isMobile ? this.$store.dispatch('showHeader',false) : '';
    },
    methods : {
      goBack() {
        this.$store.dispatch('goBack');
        this.$router.push({name: "challengesHome"});
        if (this.isMobile){
          this.$store.dispatch('showHeader',true);
          this.$store.dispatch('showFooter',true);
        }
      },
      swipeRightHandler () {
          this.goBack();
      },
      activeTab() {
        this.tabIndex = this.$route.params.subcat || 0;
      },
      activeTheTab(){
          // this.tabIndex = 5;
          // const target = document.querySelector('[data-name="Messagerie"]');
          // target.style.display = "block";
          // target.classList.add('test');
          // console.log("activeTheTab -> target", target)
        }
    },
    beforeDestroy: function () {
  },
    watch: {
        '$route.params.subcat': function () {
          this.activeTab()
        },
      getIsMobile(){
          this.isMobile = this.getIsMobile;
      }
      },
  };
</script>
